<div class="row match-height">
  <div class="col-xl-12 col-lg-12">
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header justify-content-between align-items-center">
            <h4 class="card-title m-0">Payments</h4>
            <p class="text-muted small mb-2 mt-1">Change banking information. Information provided will be securely stored directly in Wise.</p>

            <button *ngIf="!isFormVisible" (click)="showPaymentForm()" class="btn btn-primary text-white fw-semibold d-inline-flex align-items-center mb-3">
              <i class="fa fa-plus mr-2"></i>  Add Banking Info via Secure Wise Connection
            </button>
          </div>
          <div id="paymentFormContainer" *ngIf="isFormVisible">
            <div class="card-content">
              <div class="card-body">
                <form [formGroup]="paymentTypeForm">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <label for="paymentType">Payment Type <span class="text-danger">*</span></label>
                      <div id="paymentType">
                        <ul class="list-unstyled mb-0">
                          <li class="d-inline-block mr-2">
                            <div class="radio">
                              <input type="radio" formControlName="paymentType" value="1" id="paymentType1" />
                              <label for="paymentType1">Wise Payment Direct to Bank Account (recommended)</label>
                            </div>
                          </li>
                          <li class="d-inline-block mr-2">
                            <div class="radio">
                              <input type="radio" formControlName="paymentType" value="2" id="paymentType2" />
                              <label for="paymentType2">Wise Payment Direct to Email (no automatic deposit)</label>
                            </div>
                          </li>
                        </ul>
                      </div>
                    </fieldset>
                  </div>
                </form>

                <form [formGroup]="currencyForm">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <label for="currency">Currency of Account<i class="fa fa-spinner fa-spin" *ngIf="isLoadingForm$ | async"></i></label>
                      <div id="currency">
                        <ng-select placeholder="Select Currency" formControlName="currency">
                          <ng-option *ngFor="let currency of currencyArr" [value]="currency">{{currency}}</ng-option>
                        </ng-select>
                      </div>
                      <div class="text-danger" *ngIf="submitted && currencyForm.get('currency')?.hasError('currencyNotDetected')">
                        <span class="errormessage">{{currencyForm.get('currency')?.errors?.currencyNotDetected?.errMsg}}</span>
                      </div>
                    </fieldset>
                  </div>
                </form>

                <form *ngIf="paymentTypeForm.get('paymentType').value === '1' && formResponse" [formGroup]="paymentRadioForm">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <label for="paymentTypeInnerRadio">Type</label>
                      <ul class="list-unstyled mb-0">
                        <li class="d-inline-block mr-2" *ngFor="let data of formResponse; let ind = index">
                          <div class="radio">
                            <input type="radio" formControlName="type" [value]="data.type" [id]="'radio-payment-type-' + ind" />
                            <label [for]="'radio-payment-type-' + ind">{{ data.title }}</label>
                          </div>
                        </li>
                      </ul>
                      <p *ngIf="usageInfo">{{ usageInfo}}</p>
                    </fieldset>
                  </div>
                </form>

                <form *ngIf="paymentTypeForm.get('paymentType').value === '1' && formResponse" [formGroup]="paymentSpecificForm">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <label for="accountHolderNameInput">Account Holder Name <span class="text-danger">*</span></label>
                      <div class="form-group">
                        <input type="text" id="accountHolderNameInput" class="form-control form-control-sm" placeholder="Account Holder Name" formControlName="accountHolderName" />
                      </div>
                      <div *ngIf="submitted && paymentSpecificForm.get('accountHolderName')?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      <div class="help-block mt-1 text-danger" *ngIf="submitted && paymentSpecificForm.get('accountHolderName')?.hasError('invalidAccName')">
                        <ng-container>
                          {{ paymentSpecificForm.get('accountHolderName')?.errors?.invalidAccName?.errMsg }}
                        </ng-container>
                      </div>
                    </fieldset>
                  </div>

                  <div class="col-12" *ngFor="let field of selectedForm">
                    <ng-container *ngFor="let group of field.group">
                      <fieldset class="form-group" *ngIf="group.type == 'radio'">
                        <label>{{ group.name }} <span *ngIf="group.required" class="text-danger">*</span></label>
                        <ul class="list-unstyled mb-0" *ngIf="group.valuesAllowed && group.valuesAllowed.length > 0; else booleanRadio">
                          <li class="d-inline-block mr-2" *ngFor="let rd of group.valuesAllowed; let ind = index">
                            <div class="radio">
                              <input type="radio" [formControlName]="group.key" [value]="rd.key" [id]="'rad' + group.key +  ind" [required]="group.required" />
                              <label [for]="'rad' + group.key + ind">{{ rd.name }}</label>
                            </div>
                          </li>
                        </ul>
                        <ng-template #booleanRadio>
                          <ul class="list-unstyled mb-0">
                            <li class="d-inline-block mr-2">
                              <div class="radio">
                                <input type="radio" [formControlName]="group.key" [value]="true" [id]="'rad-' + group.key + '-yes'" />
                                <label [for]="'rad-' + group.key + '-yes'">Yes</label>
                              </div>
                            </li>
                            <li class="d-inline-block mr-2">
                              <div class="radio">
                                <input type="radio" [formControlName]="group.key" [value]="false" [id]="'rad-' + group.key + '-no'" />
                                <label [for]="'rad-' + group.key + '-no'">No</label>
                              </div>
                            </li>
                          </ul>
                        </ng-template>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.pattern" class="help-block mt-1 text-danger">
                          Invalid format <ng-container *ngIf="group.example">e.g, {{ group.example }}</ng-container>
                        </div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      </fieldset>

                      <fieldset class="form-group" *ngIf="group.type == 'select'">
                        <label>{{ group.name }} <span *ngIf="group.required" class="text-danger">*</span></label>
                        <div class="form-group">
                          <ng-select [placeholder]="group.name" [formControlName]="group.key">
                            <ng-option *ngFor="let opt of group.valuesAllowed" [value]="opt.key">{{opt.name}}</ng-option>
                          </ng-select>
                        </div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.pattern" class="help-block mt-1 text-danger">Invalid format <ng-container *ngIf="group.example">e.g, {{ group.example }}</ng-container></div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      </fieldset>

                      <fieldset class="form-group" *ngIf="group.type == 'text'">
                        <label>{{ group.name }} <span *ngIf="group.required" class="text-danger">*</span></label>
                        <div class="form-group">
                          <input type="text" class="form-control form-control-sm" [placeholder]="group.name" [formControlName]="group.key" />
                        </div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.pattern" class="help-block mt-1 text-danger">Invalid format <ng-container *ngIf="group.example">e.g, {{ group.example }}</ng-container></div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      </fieldset>

                      <fieldset class="form-group" *ngIf="group.type == 'email'">
                        <label>{{ group.name }} <span *ngIf="group.required" class="text-danger">*</span></label>
                        <div class="form-group">
                          <input type="email" class="form-control form-control-sm" [placeholder]="group.name" [formControlName]="group.key" />
                        </div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.pattern" class="help-block mt-1 text-danger">Invalid format <ng-container *ngIf="group.example">e.g, {{ group.example }}</ng-container></div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.email" class="help-block mt-1 text-danger">Please enter a valid email!</div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      </fieldset>

                      <fieldset class="form-group" *ngIf="group.type == 'number'">
                        <label>{{ group.name }} <span *ngIf="group.required" class="text-danger">*</span></label>
                        <div class="form-group">
                          <input type="number" class="form-control form-control-sm" [placeholder]="group.name" [formControlName]="group.key" />
                        </div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.pattern" class="help-block mt-1 text-danger">Invalid format <ng-container *ngIf="group.example">e.g, {{ group.example }}</ng-container></div>
                        <div *ngIf="submitted && paymentSpecificForm.get(group.key)?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      </fieldset>
                    </ng-container>
                  </div>

                  <div class="col-12">
                    <fieldset class="form-group">
                      <label>Email Address for Wise Receipt<span class="text-danger">*</span></label>
                      <br />
                      <label class="text-muted">
                        Wise sends a payment receipt each time a transfer is made. Enter the email address where you'd like these receipts delivered.
                        <br />
                        <b>Email address for Wise account is permanent and can not be changed later.</b>
                      </label>
                      <div class="form-group">
                        <input type="email" class="form-control form-control-sm" placeholder="Email" formControlName="email" />
                      </div>
                      <div *ngIf="submitted && paymentSpecificForm.get('email')?.errors?.email" class="help-block mt-1 text-danger">Please enter a valid email!</div>
                      <div *ngIf="submitted && paymentSpecificForm.get('email')?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                    </fieldset>
                  </div>
                </form>

                <form *ngIf="paymentTypeForm.get('paymentType').value === '2'" [formGroup]="emailForm">
                  <div class="col-12">
                    <fieldset class="form-group">
                      <label>Account Holder Name <span class="text-danger">*</span></label>
                      <div class="form-group">
                        <input type="text" class="form-control form-control-sm" placeholder="Account Holder Name" formControlName="accountHolderName" />
                      </div>
                      <div *ngIf="submitted && emailForm.get('accountHolderName')?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                      <div class="help-block mt-1 text-danger" *ngIf="submitted && emailForm.get('accountHolderName')?.hasError('invalidAccName')">
                        <ng-container>{{ emailForm.get('accountHolderName')?.errors?.invalidAccName?.errMsg }}</ng-container>
                      </div>
                    </fieldset>

                    <fieldset class="form-group">
                      <label>Email Address for Wise Receipt<span class="text-danger">*</span></label>
                      <br />
                      <label class="text-muted">
                        Wise sends a payment receipt each time a transfer is made. Enter the email address where you'd like these receipts delivered.
                        <br />
                        <b>Email address for Wise account is permanent and can not be changed later.</b>
                      </label>
                        
                          <div class="form-group">
                            <input type="email" class="form-control form-control-sm" placeholder="Email" formControlName="email" />
                          </div>
                          <div *ngIf="submitted && emailForm.get('email')?.errors?.email" class="help-block mt-1 text-danger">Please enter a valid email!</div>
                          <div *ngIf="submitted && emailForm.get('email')?.errors?.required" class="help-block mt-1 text-danger">This field is required!</div>
                    </fieldset>
                  </div>
                </form>
              </div>
            </div>
            <div class="card-footer">
              <button class="btn btn-sm btn-primary mr-2" (click)="submit()">Update Setting</button>
              <button class="btn btn-sm btn-secondary mr-2" (click)="cancelPayment()">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
